import defaultTpl from "../assets/templates/ReadBarcodes_Default.json";
import speedTpl from "../assets/templates/ReadBarcodes_SpeedFirst.json";
import readRateTpl from "../assets/templates/ReadBarcodes_ReadRateFirst.json";

type TypeDefaultTpl = typeof defaultTpl;
type TypeSpeedTpl = typeof speedTpl;
type TypeReadRateTpl = typeof readRateTpl;
type UniteTypeTpl = TypeDefaultTpl|TypeSpeedTpl|TypeReadRateTpl;

export type { TypeDefaultTpl, TypeSpeedTpl, TypeReadRateTpl, UniteTypeTpl }

export type DivRef = React.MutableRefObject<HTMLDivElement | null>

export type InputRef = React.MutableRefObject<HTMLInputElement | null>

export type PreRef = React.MutableRefObject<HTMLPreElement | null>

export type PreArrRef = React.MutableRefObject<Array<HTMLPreElement>>

export type DivArrRef = React.MutableRefObject<Array<HTMLDivElement>>

export type AnyRef = React.MutableRefObject<any>

export type CanvasArrRef = React.MutableRefObject<Array<HTMLCanvasElement | null>>

export type VideoRef = React.MutableRefObject<HTMLVideoElement | null>

export type SelectRef = React.MutableRefObject<HTMLSelectElement | null>

export type GrayscaleTransformationMode = "GTM_ORIGINAL" | "GTM_INVERTED" | "GTM_AUTO";

export type ScanningMode = 0 | 1 | 2; // 0 = SpeedFirst, 1 = Default, 2 = ReadRateFirst

const colourMap: {
  both: GrayscaleTransformationMode[],
  normal: GrayscaleTransformationMode[],
  inverted: GrayscaleTransformationMode[]
} = {
  "both": ["GTM_ORIGINAL", "GTM_INVERTED", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO"],
  "normal": ["GTM_ORIGINAL", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO"],
  "inverted": ["GTM_INVERTED", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO", "GTM_AUTO"]
};

export { colourMap };